module.exports = __webpack_public_path__ + "static/bird-by-bird-e4271f961f229a39597cc33c80615eab.jpg";